<template>
  <div class="dialog">
    <el-dialog
      title="修改记录"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-table :data="handleList">
        <el-table-column
          align="center"
          property="date"
          label="修改时间"
          width="200"
        >
          <template slot-scope="{ row }">
            {{ row.updateTime | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="name"
          label="生效时间"
          width="200"
        >
          <template slot-scope="{ row }">
            {{ row.enableDt | transAllTime }}
          </template>
        </el-table-column>
        <el-table-column property="address" label="修改来源" align="center">
          <template slot-scope="{ row }">
            {{ row.enterpriseId || row.userId || user.id }}
          </template>
        </el-table-column>
        <el-table-column
          property=" address
          "
          label="修改记录"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="checkout(scope)">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
      <div slot="footer">
        <el-button type="primary" style="margin-top: 1em" @click="close">
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="详情"
      v-if="showDetail"
      :visible="showDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <component
        :is="currComponent"
        :obj="detailObj"
        :listobj="listObj"
        :isDialog="true"
      ></component>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDetail = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseHospital from './baseHospital';
import lvlHospital from './lvlHospital';
import otc from './otc';
import academy from './academy';
import digital from './digital';
import editScene from './editScene.vue';
import { pageInation } from '@/Mixin/listMixin';
import { getStorage } from '@/tools/storage';

export default {
  name: 'dialoge',
  mixins: [pageInation],
  props: {
    ajax: {
      type: Object,
      default() {
        return {};
      }
    },
    visible: {
      default: true
    }
  },
  data() {
    return {
      currComponent: '',
      rootItem: { data: null },
      user: { username: '', id: '' },
      showDetail: false,
      detailObj: {},
      searchQuery: {},
      listObj: [],
      getList: this.ajax.list // 获取列表的AJAX
    };
  },
  components: {
    baseHospital,
    lvlHospital,
    otc,
    academy,
    digital,
    editScene
  },
  watch: {},
  computed: {
    handleList() {
      let list = this.tableData;
      let formedList = [];
      try {
        if (Array.isArray(list))
          for (let item of list) {
            const obj = JSON.parse(item.updateJson || '[]');
            obj['baseRiskObj'] = JSON.parse(item.primaryJson || '[]');
            formedList.push(obj);
          }
      } catch (e) {
        return [];
      }
      return formedList;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    checkout(e) {
      //todo 处理查看详情
      let { row } = e;
      try {
        let obj = row;
        this.currComponent = this.$parent.curr;
        this.detailObj = obj;
        this.listObj = obj.baseControlDistance || [];
        this.showDetail = true;
      } catch (e) {
        console.error(e);
      }
    }
  },
  created() {
    Object.assign(this.searchQuery, this.$parent.dialogQuery);
    this.user = getStorage('user') || {};
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.dialog {
  .el-dialog {
    width: 90vw;
    /*标题样式*/
    .el-dialog__header {
      background-color: #5a9cf8;
      padding: 0px;
      height: 48px;

      .el-dialog__title {
        font-size: 20px;
        color: #ffffff;
      }
    }

    /*输入框后面加<元>*/
    .el-dialog__body {
      padding: 30px;
      border-bottom: 1px #dfe1e6 solid;

      .el-form-item {
        margin-bottom: 15px;
      }
    }

    /*底部按钮居中和大小*/
    .el-dialog__footer {
      height: 89px;
      padding: 0;
      display: flex;
      justify-content: center;

      .dialog-footer {
        align-self: center;

        .el-button {
          width: 155px;
          height: 39px;
        }
      }
    }
  }
}
</style>
